export default __webpack_public_path__ + "4e4bb53d44a818e059d73f24a68f5919.png";